import { FaqsTypesResponse } from "@/types/api";
import { api } from "./fetch";

export const apiService = {
  getFaqsTypes(slug: string, country?: string, city?: string) {
    const path = ["/get-faq-types", slug, country, city].filter(Boolean).join("/");
    return api<FaqsTypesResponse>(path);
  },
};
